/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


function _addMeToCart(e, el) {
e = e || window.event;
e.preventDefault();

let formData = {
'items': [
{
'id': el.dataset.variant_id,
'quantity': 1
}
]
};

fetch('/cart/add.js', {
method: 'POST',
headers: {
'Content-Type': 'application/json'
},
body: JSON.stringify(formData)
})
.then((resp) => {
return resp.json();
})
.then((data) => {

  setTimeout(function (e) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
bubbles: true
}));    
  },500);


})
.catch((err) => {
console.error('Error: ' + err);
})
}


/**
 * Sync main product add-to-cart label with Recharge subscription widget pricing.
 * Uses `recharge-subscription-widget.variant` and `selectedVariantPlan` so the button shows
 * the selected plan's discounted price (or unit price for one-time) after variant or plan changes.
 */
(function syncRechargeAddToCartPrice() {

  var selectedVariantId = window.selectedVariantId

  document.addEventListener('variant:change', function (e) {
    const subscriptionConfig = window.SubscriptionWidgetConfig
    const sellingID = document.querySelector('recharge-subscription-widget').sellingPlanId

    selectedVariantId = e.detail.variant.id

    const subscriptionVariant = subscriptionConfig.formattedPrices[selectedVariantId]

    if (subscriptionVariant) {
      const discountedPrice = subscriptionVariant.discounted
      const unitPrice = subscriptionVariant.unit

      if (sellingID) {
        if (discountedPrice) {
          document.querySelector('.product-info__block-list .buy_button__price').innerHTML = discountedPrice
        }
      } else {
        if (unitPrice) {
          document.querySelector('.product-info__block-list .buy_button__price').innerHTML = unitPrice
        }
      }
    }
  })

  document.querySelector('recharge-subscription-widget').addEventListener('click', function (e) {

    setTimeout(() => {
        
      const subscriptionConfig = window.SubscriptionWidgetConfig
      const sellingID = document.querySelector('recharge-subscription-widget').sellingPlanId

      console.log(sellingID)

      const subscriptionVariant = subscriptionConfig.formattedPrices[selectedVariantId]

      if (subscriptionVariant) {
        const discountedPrice = subscriptionVariant.discounted
        const unitPrice = subscriptionVariant.unit

        if (sellingID) {
          if (discountedPrice) {
            document.querySelector('.product-info__block-list .buy_button__price').innerHTML = discountedPrice
          }
        } else {
          if (unitPrice) {
            document.querySelector('.product-info__block-list .buy_button__price').innerHTML = unitPrice
          }
        }
      }
    }, 100);
  })
})();


$(window).on('load', function() {

  $(function(){
    $(".twentytwenty-container").each(function() {
      $(this).twentytwenty({
        default_offset_pct: 0.7, // How much of the before image is visible when the page loads
        orientation: 'horizontal', // Orientation of the before and after images ('horizontal' or 'vertical')
        no_overlay: true, //Do not show the overlay with before and after
        move_slider_on_hover: false, // Move slider on mouse hover?
        move_with_handle_only: true, // Allow a user to swipe anywhere on the image to control slider movement.
        click_to_move: true // Allow a user to click (or tap) anywhere on the image to move the slider to that location.
      });
    });
  });

});